<template>
  <div class="dialog-export-container">
    <el-button @click="exportList">
      一键导出
    </el-button>
    <dialogCommon
      ref="export"
      width="450px"
      class="dialog-export"
      :is-show-footer="true"
      :is-diolog-append-body="isDiologAppendBody"
      @dialogSure="exportSure"
    >
      <div class="text">
        单次最多允许导出5000条记录
      </div>
    </dialogCommon>
  </div>
</template>

<script>
import dialogCommon from '@components/dialog/cyDialogCommon'
import { exportFileTime, fileDownLoad } from '@common/util.js'
export default {
  name: 'DialogExport',
  props: {
    total: {
      type: Number,
      default: 0
    },
    maxExportNumber: {
      type: Number,
      default: 5000
    },
    exportFileName: {
      type: String,
      default: ''
    },
    downloadUrl: {
      type: String,
      default: ''
    },
    downloadParams: {
      type: Object,
      default: () => {}
    },
    isDiologAppendBody: {
      type: Boolean,
      default: true
    }
  },
  components: {
    dialogCommon
  },
  data() {
    return {}
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    exportList() {
      if (this.total > this.maxExportNumber) {
        this.$refs.export.cyDialogCommon = true
        return false
      }
      this.exportSure()
    },
    exportSure() {
      let fileName = `${this.exportFileName}-${exportFileTime()}.xlsx`
      this.$refs.export.cyDialogCommon = false
      fileDownLoad(this.downloadUrl, this.downloadParams, fileName)
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-export {
  /deep/ .el-dialog.cy-dialog-common {
    .el-dialog__body {
      padding: 20px 0;
      .text {
        text-align: center;
      }
    }
  }
}
</style>
